'use client'

const ErrorPage = () => <div className=''></div>

export default ErrorPage
